module.exports = __webpack_public_path__ + "static/img/iconmenu02_white.7f0e69d8.svg";